import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PixelgrokLanding from "./pages/PixelgrokLanding";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<PixelgrokLanding />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
